import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Production log hygiene: silence console.log/console.warn in production builds.
// console.error is preserved — real errors should still surface for Sentry/GTM error reporting.
// Wraps 46 scattered logging calls across the codebase in one no-op pass at app boot.
if (process.env.NODE_ENV === "production") {
  // eslint-disable-next-line no-empty-function
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}

const rootElement = document.getElementById("root");

// Support react-snap pre-rendering with hydration
if (rootElement.hasChildNodes()) {
  // Hydrate if pre-rendered HTML exists (production with react-snap)
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // Regular render for development
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}
